
import React, { useState } from 'react';
import { RiQuestionLine } from 'react-icons/ri';
import { submitUpdateSupplierStatus } from '../../../../Actions/supplierActions';
import { useGlobalContext } from '../../../../Contexts/GlobalContext';
import MultiSelectDropdown from '../../../../components/MultiSelectDropdown';
import { Button, Modal } from '../../../../components/UiComponents/Ui';
import SubmitButton from '../../../../components/UiComponents/SubmitButton';



const options = [
  {
    label: 'Active',
    value: 1,
  },
  {
    label: 'Inactive',
    value: 2,
  },
];

const ChangeSupplierStatus = ({ _id, supplierStatus }) => {
  const { setSnackbar,  } = useGlobalContext();
  const [supplierStatusChange, setSupplierStatusChange] = useState({});

  const selectedValue = supplierStatus
    ? {
        label: 'Active',
        value: 1,
      }
    : {
        label: 'Inactive',
        value: 2,
      };

  const handleSubmit = async () => {
    try {
      const response = await submitUpdateSupplierStatus({
        supplierStatus:
          supplierStatusChange?.status?.value === 1 ? true : false,
        supplierID: _id,
      });
      if (!response?.error) {
        setSnackbar({
            open: true,
            message: 'Supplier status updated Successfully!',
            type: 'success',
        })
      } else {
        setSnackbar({
            open: true,
            message: 'Internal Server Error! Please try again!',
            type: 'error',
        })
      }
      setSupplierStatusChange({});
    } catch (error) {
      console.log('error in project status change handleSubmit', error);
      setSnackbar({
        open: true,
        message: 'Internal Error! Please try again!',
        type: 'error',
      })
      setSupplierStatusChange({});
    }
  };

  return (
    <div className="flex gap-3 items-center">
      <MultiSelectDropdown
        options={options}
        selected={
          supplierStatusChange?.open
            ? [
                {
                  label: supplierStatusChange?.status?.label || '',
                  value: supplierStatusChange?.status?.value || '',
                },
              ]
            : [
                {
                  label: selectedValue?.label || '',
                  value: selectedValue?.value || '',
                },
              ]
        }
        dropdownText="Status"
        width="150px"
        setSelected={(e) => {
          const changeValue = e ;
        
          if(changeValue?.[0]?.value === supplierStatus) {
            return;
          }
          setSupplierStatusChange({
            status: {
              label: changeValue?.[0]?.label || '',
              value: changeValue?.[0]?.value,
            },
            open: true,
          });
        }}
      />

      {/* CHANGE SURVEY STATUS MODAL */}
      <Modal
        showModal={supplierStatusChange?.open}
        setShowModal={() => {
          setSupplierStatusChange({});
        }}
        closeModal={true}
        className="!w-[500px]"
      >
        <form className="space-y-6" action={handleSubmit}>
          <div className="flex gap-2">
            <div>
              <RiQuestionLine size={20} className="text-warning-600 mt-1" />
            </div>
            <div className="space-y-2">
              <h2 className="text-gray-800 text-lg font-bold">Change Status</h2>
              <p className="text-gray-500 text-sm font-[400] w-[90%]">
                This will change the status of this supplier as{' '}
                <b className="capitalize text-gray-900">
                  {supplierStatusChange?.status?.label}
                </b>{' '}
                . Are you sure you want to continue?
              </p>
            </div>
          </div>
          <div className="flex justify-end gap-2">
            <Button
              variant="outlined"
              intent="default-outlined"
              size="sm"
              type="button"
              onClick={() => {
                setSupplierStatusChange({});
              }}
            >
              Cancel
            </Button>
            <SubmitButton
              name="Confirm"
              size="sm"
              intent="warning"
              variant="filled"
            />
          </div>
        </form>
      </Modal>
    </div>
  );
};

export default ChangeSupplierStatus;
